import { next } from "@wordpress/icons";

jQuery(document).ready(function () {
  if (jQuery(".slider")) {
    initializeSlider(jQuery(".slider"));
  }
});
/* 
 * En el siguiente ejemplo se añade la clase .slider al listado <ul> y se convierte en lo siguiente:
  <div class="slider">  <- wrapper
    <ul class="slider-container" data-current="1">  <- container
      <li class="slide-item active">...</li>  <- items
      <li class="slide-item">...</li>
      ...
    </ul>
    <div class="blocks-slider-navigation">
      <div class="prev_btn"></div>
      <div class="next_btn"></div>
    </div>
  </div>
*/
const allowedClasses = [
  "slider",
  "white-arrows",
  "blue-arrows",
  "green-arrows",
  "arrows-with-overlay",
  // "dots",
  // "my-custom-class",
];
function initializeSlider(sliders) {
  //console.log(sliders);
  // Several sliders might exist on the same page (.blocks-slider)
  sliders.each((index, slider) => {
    const $slider = jQuery(slider);
    let $wrapper; // elemento raíz sobre el que añadimos la navegación
    let $container; // .slider-container (flex con los items)

    //Envolver el slider en un div.slider para convertirlo en el $container
    $slider.wrap('<div class="slider"></div>');
    // Guardar las clases originales del slider
    const originalClasses = ($slider.attr("class") || "").split(" ");
    const filtered = originalClasses.filter((cls) =>
      allowedClasses.includes(cls)
    );
    $slider.removeClass("slider");

    // Set first item as active and add container class
    $container = $slider;
    $container.addClass("slider-container").attr("data-current", 1);
    jQuery($container.children()[0]).addClass("active");

    // Convertimos el $slider.wrap() en el $wrapper
    $wrapper = $slider.parent(); // <div class="slider">
    // Añadir al wrapper todas las clases del original excepto "slider"
    filtered.forEach((cls) => {
      if (cls && cls !== "slider") {
        $wrapper.addClass(cls);
      }
    });
    // Include navigation
    appendNavigationSlider($wrapper[0]);
    // Reposiciona slider
    repositionSlider(slider);
    // Escucha el evento resize para reposicionar los slides
    const $win = jQuery(window);
    if (!$win.data("slider-resize-bound")) {
      $win.on("resize.slider", function () {
        jQuery(".slider").each(function (i, slider) {
          repositionSlider(slider);
        });
      });
      $win.data("slider-resize-bound", true);
    }
  });
}

function appendNavigationSlider(slider) {
  jQuery(slider).append(
    '<div class="blocks-slider-navigation"><div class="prev_btn"></div><div class="next_btn"></div></div>'
  );
  jQuery(slider)
    .find(".blocks-slider-navigation .prev_btn")
    .on("click", function () {
      move(slider, "prev");
    });
  jQuery(slider)
    .find(".blocks-slider-navigation .next_btn")
    .on("click", function () {
      move(slider, "next");
    });
  // ToDo: optional, include dots
}

function getSliderState(slider) {
  const $container = jQuery(slider).find(".slider-container");
  const $slides = $container.children();
  const numItems = $slides.length;

  if (!numItems) return null;

  // índice actual (data-current es 1-based)
  let current = parseInt($container.attr("data-current")) || 1;
  let currentIndex = current - 1; // 0-based

  // medidas
  const containerWidth = $container[0].getBoundingClientRect().width;
  //console.log(containerWidth);
  const slideWidth = $slides[0].getBoundingClientRect().width;

  const styles = getComputedStyle($container[0]);
  const gapValue =
    parseFloat(styles.gap) ||
    parseFloat(styles.columnGap) ||
    parseFloat(styles.rowGap) ||
    0;

  const offsetPx = slideWidth + gapValue;
  const step = (offsetPx / containerWidth) * 100;
  const visibleCount = Math.max(1, Math.round(containerWidth / offsetPx));
  const maxIndex = Math.max(0, numItems - visibleCount);

  return {
    $container,
    $slides,
    numItems,
    currentIndex,
    step,
    maxIndex,
  };
}

// 2) Helper: posiciona el slider en un índice dado
function applySliderPosition(state, targetIndex, animate) {
  const { $container, $slides, step, maxIndex } = state;

  // clamp del índice
  let index = targetIndex;
  if (index > maxIndex) index = maxIndex;
  if (index < 0) index = 0;

  const x = -step * index;

  // actualizar data-current (1-based)
  $container.attr("data-current", index + 1);

  // mover slides
  const $anim = $slides.css("left", x + "%");
  if (animate) {
    $anim.animate(500);
  }

  // clase active
  $slides.removeClass("active");
  jQuery($slides[index]).addClass("active");
}

// 3) MOVE: calcula nextIndex y delega
function move(slider, direction) {
  const state = getSliderState(slider);
  if (!state) return;

  const { currentIndex, maxIndex } = state;

  let nextIndex = currentIndex;

  if (direction === "next") {
    nextIndex = currentIndex + 1;
    if (nextIndex > maxIndex) nextIndex = 0; // loop al principio
  } else if (direction === "prev") {
    nextIndex = currentIndex - 1;
    if (nextIndex < 0) nextIndex = maxIndex; // loop al último grupo
  }

  applySliderPosition(state, nextIndex, true); // con animación
}

// 4) REPOSITION: mismo cálculo, pero sin cambiar de slide ni animar
function repositionSlider(slider) {
  const state = getSliderState(slider);
  if (!state) return;

  applySliderPosition(state, state.currentIndex, false);
}
